export const EXPORT_LOCALES = [
  { value: 'ar', label: 'Arabic' },
  { value: 'bg-BG', label: 'Bulgarian' },
  { value: 'cs-CZ', label: 'Czech' },
  { value: 'de-DE', label: 'German' },
  { value: 'en-GB', label: 'English (UK)' },
  { value: 'en-US', label: 'English (US)' },
  { value: 'es-ES', label: 'Spanish' },
  { value: 'et-EE', label: 'Estonian' },
  { value: 'fa-IR', label: 'Farsi' },
  { value: 'fr-FR', label: 'French' },
  { value: 'he-IL', label: 'Hebrew' },
  { value: 'hr-HR', label: 'Croatian' },
  { value: 'hu-HU', label: 'Hungarian' },
  { value: 'it-IT', label: 'Italian' },
  { value: 'lt-LT', label: 'Lithuanian' },
  { value: 'lv-LV', label: 'Latvian' },
  { value: 'nl-NL', label: 'Dutch' },
  { value: 'pl-PL', label: 'Polish' },
  { value: 'pt-PT', label: 'Portuguese' },
  { value: 'ro-RO', label: 'Romanian' },
  { value: 'ru-RU', label: 'Russian' },
  { value: 'sk-SK', label: 'Slovak' },
  { value: 'sl-SI', label: 'Slovenian' },
  { value: 'sv-SE', label: 'Swedish' },
];
